export default __webpack_public_path__ + "img/oval.d014285f.svg";